export default __webpack_public_path__ + "static/media/OCRB Medium.bbce6645.ttf";